<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="30">
        <el-col :span="18">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">Certs Sent</h4>
              <div class="table-responsive">
                 <el-col :span="5">
                    <label class="control-label">Region:</label>
                    <br />
                    <el-select v-model="filters[1].value" placeholder="select region"   @change="getSts">
                      <el-option label="All" value="ALL"></el-option>
                      <el-option label="UK" value="TEFLORG"></el-option>
                      <el-option label="US" value="TEFLUS"></el-option>
                      <el-option label="EU" value="IRELAND"></el-option>
                    </el-select>
                  </el-col>
                   <el-col :span="14">
                     <label class="control-label">Dates:</label><br />
                <el-date-picker
                  @change="getSts"
                  v-model="filters[2].value"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="-"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  :picker-options="pickerOptions1"
                ></el-date-picker>
                <el-button @click="createCsv()">Download Csv</el-button>
               Total: {{total}}
                   </el-col>
              </div>
            </div>
          </el-card>
          <el-card>
            <div>
              <el-row>
                <el-col>
                  <data-tables-server
                    id="tables"
                    class="table-shopping"
                    @query-change="getSts"
                    :data="sts"
                    :loading="loadingSts"
                    :page-size="10"
                    :total="total"
                    :current-page="1"
                    :tool-bar="false"
                    :pagination-def="paginationDef"
                  >
               

                    <el-table-column prop="id" label="Order ID" width="100"></el-table-column>

                     <el-table-column prop="customer.firstname" label="Firstname" width="180"></el-table-column>
                     <el-table-column prop="customer.lastname" label="Lastname" width="180"></el-table-column>
                        <el-table-column prop="customer.email" label="Email" width="250"></el-table-column>
                    <el-table-column prop="productPriceLabel" label="Price Label" width="180"></el-table-column>
                      <el-table-column prop="boughtProducts[0].certSentDate" label="Sent Date" width="180"></el-table-column>
               
                  </data-tables-server>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
                     </el-table-column>
                  </data-tables-server>
                </el-col>
              </el-row>
            </div>
          </el-card>
     
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import gql from "graphql-tag";
import moment from "moment";
import _ from "lodash";
export default {
  data() {
    return {
      loadingSts: false,
      total: 0,
      sts: [],
      oStatus:{0:"Pending",1:"Partially Paid",2:"Fully Paid",3:"Fully Refunded",4:"Cancelled"},
      stsAgrregate: {},
      paginationDef: { pageSize: 10, pageSizes: [10, 20, 100], currentPage: 1 },
      filters: [
        {
          value: "2",
          prop: "status"
        },
        {
          value: "ALL",
          prop: "productPriceLabel"
        },
        {
          value: [
            moment()
              .subtract(1, "months")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ],
          prop: "dateCreated"
        }
      ],
      pickerOptions1: {
        shortcuts: [
          {
            text: "Last 24 hours",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Two Weeks",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "3 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "6 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "1 year",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  methods: {
    async getSts(queryInfo) {
      var startDate = moment(this.filters[2].value[0]).format("YYYY-MM-DD");
      var endDate = moment(this.filters[2].value[1]).format("YYYY-MM-DD");
      var equal = this.filters[1].value === "ALL" ? "_neq" : "_eq"
      this.loadingSts = true;
      console.log(queryInfo);
      if (queryInfo) {
        var { pageSize, page } = queryInfo;
      }
      let query = gql`
     
         query MyQuery {
  Order(where: {boughtProducts: {certSent: {_eq: "1"}, _and: [
    {productPriceLabel: {${equal}: "${this.filters[1].value}"}},
    {certSentDate: {_gte: "${startDate}"}}, {certSentDate: {_lte: "${endDate}"}}, {certSentDate: {_is_null: false}}]}}) {
    boughtProducts(where: {product: {type: {_in: ["classroom course","combined course","online course"]}}}){
      certSentDate
    }
    customer{
      firstname
      lastname
      email
    }
    productPriceLabel
    id
  }
  Order_aggregate(where: {boughtProducts: {certSent: {_eq: "1"}, _and: [
    {productPriceLabel: {${equal}: "${this.filters[1].value}"}},
    {certSentDate: {_gte: "${startDate}"}}, {certSentDate: {_lte: "${endDate}"}}, {certSentDate: {_is_null: false}}]}}) {
    aggregate {
      count
    }
  }
}`;
      console.log(query);
      this.$apollo
        .query({
          fetchPolicy: "no-cache",
          query: query,
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.stsAgrregate = response.data.Order_aggregate;
          this.total = this.stsAgrregate.aggregate.count;
          this.sts = response.data.Order;
          this.loadingSts = false;
        });
    },
    createCsv(){
         let csvData=this.sts

      // Empty the array first in case it has data from a previous query
      let csvArr = new Array(csvData.length);
      var sLen = csvData.length;
      // console.log(sLen);

      for (var i = 0; i < sLen; i++) {
       
        csvArr.push([
            csvData[i].id,
            csvData[i].customer.firstname,
            csvData[i].customer.lastname,
            csvData[i].customer.email,
          //  sales[i].customer.shippingAddress ? sales[i].customer.shippingAddress.line1 +" "+sales[i].customer.shippingAddress.line2+" "+sales[i].customer.shippingAddress.town : '',
            csvData[i].productPriceLabel,

            csvData[i].boughtProducts[0].certSentDate
           
        ]);   
      }

      let csvContent =
        [
          [      "Order ID",
            "Customer Firstname",
            "Customer Lastname",
            "Customer Email",
            "Region",
            "Product ID",
            "Sent Date"
        
            
          ]
        ] + "\r";

      csvArr.forEach(rowArray => {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });

      var fileURL = window.URL.createObjectURL(
        new Blob([csvContent], { type: "text/csv" })
      );
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", "CertsSent-"+this.filters[1].value +"-( "+moment(this.filters[2].value[0]).format("DD/MM/YYYY") +" - "+moment(this.filters[2].value[1]).format("DD/MM/YYYY")+ " ).csv");
      document.body.appendChild(fileLink);
        this.loadingSts=false,
      fileLink.click();
    }



    }
  
};
</script>


// WEBPACK FOOTER //
// src/components/Reports/CertsSent.vue